import React , {useState,useEffect} from 'react'
import styles from './customersWidgets.module.scss'
import { Col, Row } from 'react-bootstrap'
import { GET_CUSTOMERS_WIDGETS } from '../../../../../Utils/GlobalConstants';
import { api } from '../../../../../Utils/API';

const CustomersWidgets = ({Logout,activeWidget,setActiveWidget,setActiveWidgetFlag}) => {
  const [customerWidget, setCustomerWidget] = useState(null);
  // Header Authorization for General API's
  const config = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
  };

  // Function to call all Customer count data
  async function GetCustomerWidget() {
    await api.get(`${GET_CUSTOMERS_WIDGETS}`, config)
      .then(resp => {
       
        setCustomerWidget(resp.data); 
      })
      .catch(error => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else {
        }
      });
  };

  useEffect(() => {
    GetCustomerWidget()
  }, [])

  return (
    <Row className='my-3'>
      {
        customerWidget && customerWidget.map((widget)=>{
          if(widget.widgetTitle==="Active Customers"){
            return(
              <Col lg={2} md={3} xs={5} className={`${styles["widget-body"]} ${styles["widget-wrapper"]} ${activeWidget===widget.widgetTitle ? styles["widget-body-highlighted"] : ""} ${styles["widget-clickable"]} px-3 mx-2 mr-4`} onClick={()=>{setActiveWidget(widget.widgetTitle);setActiveWidgetFlag(true);}}>
                <span>{widget.widgetTitle}</span>
                <h3 className={`${styles["widget-body-green"]} ${styles["active-customer-padding-top"]}`}>{`${Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format((parseInt(widget.count)).toFixed(2))}`}</h3>
                 {activeWidget===widget.widgetTitle && (
                  <div className={styles["success-bubble"]}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.5 4.5L6 12L2.5 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                )}
              </Col>
            )
          }
          else{
            return(
              <Col lg={2} md={3} xs={5} className={`${styles["widget-body"]} ${styles["widget-wrapper"]} ${activeWidget===widget.widgetTitle ? styles["widget-body-highlighted"] : ""} ${styles["widget-clickable"]} px-3 mx-2 mr-4`} onClick={()=>{setActiveWidget(widget.widgetTitle);setActiveWidgetFlag(true)}}>
                <span>{widget.widgetTitle}</span>
                <Row>
                  <Col>
                    <h3 className={`${styles["widget-body-default"]} ${widget.isIncrease ? "text-success" : "text-danger"}`}>
                      <span className={widget.isIncrease ? "dashboard-green-arrow" : "dashboard-red-arrow"}></span> 
                      {widget.count}%
                    </h3>
                  </Col>
                  <Col className='text-right'>
                  <span className={`${styles["sub-description"]} text-small mb-0`}>{`${Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format((parseInt(widget.totalCount)).toFixed(2))}`} {widget.totalCount>1 ? "Customers" : "Customer"}</span>
                  </Col>
                </Row>
                {activeWidget===widget.widgetTitle && (
                  <div className={styles["success-bubble"]}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.5 4.5L6 12L2.5 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                )}  
              </Col>
            )
          }
        })
      }
    </Row>
  )
}

export default CustomersWidgets
